import React from "react";
import { Card, Button, Badge } from "react-bootstrap";

const DEFAULT_PRODUCT_IMAGE =
  "/images/product-1.jpg";

const getProductImageUrl = (image) => {
  if (!image) {
    return DEFAULT_PRODUCT_IMAGE;
  }

  let path = String(image)
    .replace(/^\/+/, "")
    .replace(/^public[\\/]+/i, "")
    .replace(/\\/g, "/");

  return `/${path}`;
};

const StoreProductCard = ({
  product,
  quantity = 0,
  onAdd,
  onRemove,
}) => {
  const image = getProductImageUrl(
    product.image ||
    product.imageUrl ||
    product.product?.image
  );

  const name =
    product.name ||
    product.product?.title ||
    "محصول بدون نام";

  const price =
    Number(
      product.price ??
      product.amount ??
      product.product?.price ??
      0
    );

  const stock =
    product.stock ??
    product.quantity ??
    product.product?.stock;

  return (
    <Card className="bg-white border-0 rounded-3 h-100 transition-y">
      <div
        style={{
          height: 240,
          overflow: "hidden",
          borderRadius:
            "12px 12px 0 0",
        }}
      >
        <img
          src={image}
          alt={name}
          className="w-100 h-100"
          style={{
            objectFit: "cover",
          }}
          onError={(e) => {
            e.currentTarget.src =
              DEFAULT_PRODUCT_IMAGE;
          }}
        />
      </div>

      <Card.Body className="p-4">
        <div className="d-flex justify-content-between gap-2 mb-2">
          <h4 className="fs-16 mb-0">
            {name}
          </h4>

          {product.category?.title && (
            <Badge bg="light" text="dark">
              {product.category.title}
            </Badge>
          )}
        </div>

        {product.description && (
          <p className="text-secondary small mb-3">
            {product.description}
          </p>
        )}

        <h3 className="fs-20 mb-3">
          {price.toLocaleString("fa-IR")}
          <span className="fs-13 fw-normal text-secondary ms-1">
            تومان
          </span>
        </h3>

        {stock !== undefined && (
          <div className="small text-secondary mb-3">
            موجودی:{" "}
            {Number(stock).toLocaleString(
              "fa-IR"
            )}
          </div>
        )}

        {quantity > 0 ? (
          <div className="d-flex align-items-center justify-content-between border rounded-3 p-2">
            <Button
              variant="danger"
              size="sm"
              onClick={() =>
                onRemove(product)
              }
            >
              <span className="material-symbols-outlined fs-18">
                remove
              </span>
            </Button>

            <strong>
              {quantity.toLocaleString(
                "fa-IR"
              )}
            </strong>

            <Button
              variant="primary"
              size="sm"
              onClick={() =>
                onAdd(product)
              }
            >
              <span className="material-symbols-outlined fs-18">
                add
              </span>
            </Button>
          </div>
        ) : (
          <Button
            variant="primary"
            className="w-100"
            onClick={() =>
              onAdd(product)
            }
          >
            <span className="material-symbols-outlined align-middle me-1">
              shopping_cart
            </span>
            افزودن به سبد
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

export default StoreProductCard;